export const jobToTableRow = (job) => ({
  id: job.id,
  clientsId: job.clientsId,
  title: job.title,
  currentOpenings: job.vacancies[0]?.currentOpenings ?? 0,
  originalOpenings: job.originalVacancy?.currentOpenings ?? 0,
  jobLocation: job.jobLocation,
  recruitingStartDate: job.recruitingStartDate,
  jobRecruiters: job.jobRecruiters.map((e) => e.recruiter),
  atsLookUp: job.atsLookUp,
  atsLookUpSecondary: job.atsLookUpSecondary,
  jobStatus: job.jobStatus,
  jobDepartment: job.jobDepartment,
  jobGroup: job.jobGroup,
  extAtsId: job.extAtsId,
  jobHiringManagers: job.jobHiringManagers.map((e) => e.hiringManager),
  jobTier: job.jobTier,
  jobTiersTitlesId: job.jobTiersTitlesId,
  extSecondaryAtsId: job.extSecondaryAtsId,
  minPay: job.minPay,
  maxPay: job.maxPay,
  isCancel: job.isCancel,
});
